import { type RouteObject } from 'react-router'

import {
  CHARTS_2_DETAIL_TRANSACTION_PATH,
  CHARTS_2_DETAIL_URL,
  CHARTS_2_TRANSACTION_PATH,
  CHARTS_2_URL,
} from 'features/charts-v2/paths'
import { lazyComponent } from 'routes/lazy-route'

// A factory, not a hoisted const — react-router mutates a `lazy` object while
// resolving it, so two routes sharing one object silently break the second.
const charts2Page = (): ReturnType<typeof lazyComponent<'Charts2'>> =>
  lazyComponent(() => import('features/charts-v2/Container'), 'Charts2')

export const chartsV2Routes: RouteObject[] = [
  {
    path: CHARTS_2_URL,
    lazy: charts2Page(),
    handle: {
      featureKey: CHARTS_2_URL,
      sentryTransactionPath: CHARTS_2_TRANSACTION_PATH,
    },
  },
  {
    path: `${CHARTS_2_URL}/:chartsId`,
    lazy: charts2Page(),
    handle: {
      featureKey: CHARTS_2_DETAIL_URL,
      sentryTransactionPath: CHARTS_2_DETAIL_TRANSACTION_PATH,
    },
  },
]
